// frontend_react/src/pages/cart/PendingCarts.jsx

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import Modal from '../../components/Modal';


const Container = styled.div`padding: ${({ theme }) => theme.spacing[4]}; background: ${({ theme }) => theme.colors.background}; min-height: 100vh;`;
const Title = styled.h1`font-size: ${({ theme }) => theme.fontSizes.xl}; margin-bottom: ${({ theme }) => theme.spacing[4]};`;
const Table = styled.table`width:100%; border-collapse:collapse; ${({ theme }) => theme.table};`;
const TH= styled.th`border:${({ theme }) => theme.table.border}; padding:${({ theme }) => theme.table.padding}; text-align:left;`;
const TD= styled.td`border:${({ theme }) => theme.table.border}; padding:${({ theme }) => theme.table.padding};`;
const Row= styled.tr`&:nth-child(odd){background:${({ theme }) => theme.colors.surface}} &:nth-child(even){background:${({ theme }) => theme.colors.background}}`;
const Button = styled.button`padding:${({ theme }) => theme.spacing[2]} ${({ theme }) => theme.spacing[3]}; border:none; border-radius:${({ theme }) => theme.radii.sm}; cursor:pointer;`;
const RecallButton = styled(Button)`background:${({ theme }) => theme.colors.primary}; color:${({ theme }) => theme.colors.onPrimary};`;
const DeleteButton = styled(Button)`background:${({ theme }) => theme.colors.error}; color:${({ theme }) => theme.colors.onError};`;
const Message = styled.p`color:${({ theme }) => theme.colors.error};`

  export default function PendingCarts({ onRecall, onDelete }) {
  const {
    pendingCarts,
    loadPending,
    recallCart: internalRecall,
    deletePending: internalDelete,
  } = useCart();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [confirm, setConfirm] = useState({ open:false, uuid:null, action:null });
  const cancelConfirmationButtonRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    (async () => {
      setLoading(true);
      setError(null);

      try {
        await loadPending();
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    })();
  }, [loadPending]);

  const closeConfirmation = () => {
    setConfirm((state) => ({ ...state, open: false }));
  };

  const prompt = (uuid, action) => setConfirm({ open:true, uuid, action });

  const handleConfirm = async () => {
    closeConfirmation();
    try {
      if (confirm.action === 'recall') {
        if (onRecall) await onRecall(confirm.uuid);
        else {
          await internalRecall(confirm.uuid);
          navigate('/cart');
        }
      } else {
        if (onDelete) await onDelete(confirm.uuid);
        else await internalDelete(confirm.uuid);
      }
    } catch (e) {
      setError(e.message);
    }
  };

  return (
    <Container>
      <Title>Paniers en attente</Title>
      {loading && <p>Chargement…</p>}
      {error && <Message>Erreur: {error}</Message>}
      {!loading && !pendingCarts.length && <p>Aucun panier en attente.</p>}
      {pendingCarts.length > 0 && (
        <Table>
          <thead>
            <tr>
              <TH>UUID</TH>
              <TH>Date</TH>
              <TH>Total TTC</TH>
              <TH>Actions</TH>
            </tr>
          </thead>
          <tbody>
            {pendingCarts.map((p) => (
              <Row key={p.uuid}>
                <TD style={{ fontFamily: 'monospace' }}>{p.uuid}</TD>
                <TD>{new Date(p.created_at).toLocaleString()}</TD>
                <TD>€{Number(p.total_ttc ?? 0).toFixed(2)}</TD>
                <TD style={{ display: 'flex', gap: '0.5rem' }}>
                  <RecallButton onClick={() => prompt(p.uuid, 'recall')}>
                    Rappel
                  </RecallButton>
                  <DeleteButton onClick={() => prompt(p.uuid, 'delete')}>
                    Supprimer
                  </DeleteButton>
                </TD>
              </Row>
            ))}
          </tbody>
        </Table>
      )}
      {confirm.open && (
        <Modal
          onClose={closeConfirmation}
          role="alertdialog"
          ariaLabelledBy="pending-cart-confirmation-title"
          ariaDescribedBy="pending-cart-confirmation-message"
          initialFocusRef={cancelConfirmationButtonRef}
          closeOnOverlay={false}
        >
          <h2 id="pending-cart-confirmation-title">
            {confirm.action === 'recall'
              ? 'Confirmer le rappel'
              : 'Confirmer la suppression'}
          </h2>
          <p id="pending-cart-confirmation-message">
            Êtes-vous sûr ?
          </p>
          <div
            style={{
              display: 'flex',
              justifyContent: 'flex-end',
              gap: '1rem',
            }}
          >
            <RecallButton
              ref={cancelConfirmationButtonRef}
              type="button"
              onClick={closeConfirmation}
            >
              Annuler
            </RecallButton>
            <RecallButton
              type="button"
              onClick={handleConfirm}
            >
              Confirmer
            </RecallButton>
          </div>
        </Modal>
      )}
    </Container>
  );
}
